export const getMenuLabel = (value, metrics) => {
    var _a, _b;
    return (_b = (_a = metrics.find(m => m.value === value)) === null || _a === void 0 ? void 0 : _a.menu_label) !== null && _b !== void 0 ? _b : value;
};
export const getMetricDisplayLabel = (value, metrics) => {
    var _a, _b;
    if (!value)
        return '';
    return (_b = (_a = metrics.find(m => m.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value;
};
